import * as getters from "../../baseQuestion/searchableStaticDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableStaticDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableStaticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/searchableStaticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_arts",
			options: [
				{
					value: "THE002",
					text: "Acting"
				},
				{
					value: "ART001",
					text: "Art - Other"
				},
				{
					value: "MUS04",
					text: "Band"
				},
				{
					value: "MUS05",
					text: "Choir"
				},
				{
					value: "ART005",
					text: "Computer Graphics"
				},
				{
					value: "THE001",
					text: "Dance"
				},
				{
					value: "THE005",
					text: "Debate"
				},
				{
					value: "THE002",
					text: "Drama"
				},
				{
					value: "ART003",
					text: "Graphic Arts"
				},
				{
					value: "MUS02",
					text: "Instrumental"
				},
				{
					value: "MUS99",
					text: "Music - Other"
				},
				{
					value: "THE999",
					text: "Performing Arts"
				},
				{
					value: "ART004",
					text: "Photography"
				},
				{
					value: "THE004",
					text: "Theatre - Directing"
				},
				{
					value: "THE999",
					text: "Theatre - Other"
				},
				{
					value: "THE003",
					text: "Theatre - Technical/Productions"
				},
				{
					value: "MUS01",
					text: "Vocal"
				},
				{
					value: "ART002",
					text: "Visual Art"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
